module.exports = __webpack_public_path__ + "static/media/xleg_mild_right.4094c27e.png";